
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getDesigns() {
        const url = `${API_URL}/designs`;
        return axios.get(url, { headers: authHeader() });
    },
    getPaginated(params) {
        return axios.get(`${API_URL}/designs/paginated`, {
            headers: authHeader(),
            params,
        });
    },
    createData(data) {
        return axios.post(`${API_URL}/designs`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/designs/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/designs/${id}`, { headers: authHeader() });
    },
};
